<script setup>
</script>

<template>
  <div class="flex-1 overflow-auto p-6">
    <h1 class="text-2xl font-bold text-slate-900 dark:text-white">
      Ejemplo
    </h1>
  </div>
</template>
